var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58301 4.5026C5.58301 3.17015 6.66722 2.08594 7.99967 2.08594C9.33165 2.08594 10.4156 3.16937 10.4163 4.50116C10.4105 5.80642 9.39854 6.85656 8.10652 6.91229C8.03443 6.90592 7.96436 6.90656 7.90064 6.91113C6.57502 6.84316 5.58301 5.792 5.58301 4.5026Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03139 13.1007L5.02933 13.0993C4.34091 12.6403 4.05664 12.091 4.05664 11.5833C4.05664 11.0751 4.34154 10.5194 5.03554 10.0543C5.82458 9.53264 6.89855 9.25 8.00831 9.25C9.11903 9.25 10.1892 9.5331 10.9706 10.054C11.6534 10.5093 11.938 11.0581 11.9433 11.573C11.9422 12.0871 11.6569 12.6361 10.9679 13.1011C10.1833 13.6277 9.11075 13.9133 7.99997 13.9133C6.88889 13.9133 5.81605 13.6275 5.03139 13.1007Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0d7fecf5068b786774790ee8bb945169.svg";
export { ForwardRef as ReactComponent };